import { render } from "./AiShow.vue?vue&type=template&id=57e62d7a"
import script from "./AiShow.vue?vue&type=script&lang=js"
export * from "./AiShow.vue?vue&type=script&lang=js"

import "./AiShow.vue?vue&type=style&index=0&id=57e62d7a&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__